/** GSTIN row from buyer_verification. API uses document_number + status. */
export interface GstinItem {
  gstin?: string;
  document_number?: string;
  document_type?: 'gst' | 'udyam';
  gstin_status?: string;
  status?: string;
  state?: string;
  address?: string | null;
  pincode?: string | null;
}

/** Independent business verification flags; each type is verified separately. */
export interface BusinessVerificationFlags {
  is_gst_verified?: boolean;
  is_uam_verified?: boolean;
  is_shop_license_verified?: boolean;
}

export interface VerificationProfile extends BusinessVerificationFlags {
  pan_number?: string | null;
  pan_verified: boolean;
  route?: 'gst' | 'shop-license' | 'shop_license' | null;
  route_verified: boolean;
  selected_gstin?: string | null;
  gstins?: GstinItem[];
  shop_license_number?: string | null;
  shop_license_state?: string | null;
  shop_license_name?: string | null;
  shop_license_district?: string | null;
  shop_license_commencement_date?: string | null;
  shop_license_registration_date?: string | null;
  uam_number?: string | null;
  is_active?: boolean;
}

export interface BuyerVerificationData extends BusinessVerificationFlags {
  pan_number?: string;
  pan_verified: boolean;
  /** API may return `route` or `verification_route`. */
  verification_route?: 'gst' | 'shop-license' | 'shop_license' | null;
  route?: 'gst' | 'shop-license' | 'shop_license' | null;
  route_verified: boolean;
  selected_gstin?: string;
  gstins?: GstinItem[];
  shop_license_number?: string;
  shop_license_state?: string;
  uam_number?: string;
  legal_name?: string;
  legal_address?: string;
  msg?: string;
  is_active?: boolean;
}

export interface BuyerVerificationResponse {
  success: boolean;
  data: BuyerVerificationData;
}

export type VerificationStatusState = 'verifying' | 'verified' | 'failed';

export type BuyerVerificationStep =
  | 'business-details'
  | 'gstin-selection'
  | 'shop-license'
  | 'verification-status'
  | 'account-activated';

export const INDIAN_SHOP_LICENSE_STATES: readonly string[] = [
  'andhra pradesh',
  'arunachal pradesh',
  'assam',
  'bihar',
  'chhattisgarh',
  'goa',
  'gujarat',
  'haryana',
  'himachal pradesh',
  'jharkhand',
  'karnataka',
  'kerala',
  'madhya pradesh',
  'maharashtra',
  'manipur',
  'meghalaya',
  'mizoram',
  'nagaland',
  'odisha',
  'punjab',
  'rajasthan',
  'sikkim',
  'tamil nadu',
  'telangana',
  'tripura',
  'uttar pradesh',
  'uttarakhand',
  'west bengal',
  'andaman and nicobar islands',
  'chandigarh',
  'dadra and nagar haveli and daman and diu',
  'delhi',
  'jammu and kashmir',
  'ladakh',
  'lakshadweep',
  'puducherry',
];

export interface VerifyPanPayload {
  pan_number: string;
  full_name: string;
  dob: string;
}

export type ShopLicenseVerificationType = 'uam' | 'certificate';

export interface VerifyUamPayload {
  uam_number: string;
}

export interface VerifyUdyamPayload {
  udyam_number: string;
}

export interface VerifyShopLicensePayload {
  certificate_number: string;
  state: string;
  name: string;
  commencement_date: string;
  district: string;
}
